import * as MoreLinkType from 'show-page/constants/more-link-type';
import FacebookIcon from 'common/components/svg-icon/facebook';
import InstagramIcon from 'common/components/svg-icon/instagram';
import Radium from 'radium';
import styles from './styles.less';
import TumblrIcon from 'common/components/svg-icon/tumblr';
import TwitterIcon from 'common/components/svg-icon/twitter';
import { observer } from 'mobx-react';


function MoreLink(props) {
    const { link } = props;
    const backgroundColor = link.type ? props.hoverColor : props.hoverBackgroundColor;
    const color = link.type ? props.hoverBackgroundColor : props.hoverColor;
    const className = cx(styles.item, props.className, {
        [styles.iconLink]: link.type,
        [styles.textLink]: !link.type
    });
    if (!link.type && !link.title) {
        return null;
    }
    return (
        <li className={ className }>
            <a
                className={ styles.itemLink }
                href={ link.url }
                style={[
                    !Modernizr.touch && {
                        ':hover': { backgroundColor, color }
                    }
                ]}
                target='_blank'>
                { link.type === MoreLinkType.FACEBOOK &&
                <FacebookIcon className={ styles.itemIcon } /> }
                { link.type === MoreLinkType.INSTAGRAM &&
                <InstagramIcon className={ styles.itemIcon } /> }
                { link.type === MoreLinkType.TUMBLR &&
                <TumblrIcon className={ styles.itemIcon } /> }
                { link.type === MoreLinkType.TWITTER &&
                <TwitterIcon className={ styles.itemIcon } /> }
                { !link.type && link.title }
            </a>
        </li>
    );
}

MoreLink.propTypes = {
    hoverColor: React.PropTypes.string.isRequired,
    hoverBackgroundColor: React.PropTypes.string.isRequired,
    link: React.PropTypes.shape({
        title: React.PropTypes.string,
        type: React.PropTypes.string,
        url: React.PropTypes.string.isRequired
    }).isRequired
};


export default observer(Radium(MoreLink));



// WEBPACK FOOTER //
// ./src/show-page/components/more-links/link.js